import type React from 'react';

import { Checkbox } from '@vlabs/uikit/components/controls/checkbox/Checkbox';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from '../ImageCheckForm.module.sass';

function ContentCheckForm(): React.JSX.Element {
  const { t } = useTranslation();
  const { register } = useFormContext();
  return (
    <div className={st.Checks}>
      <div className={st.ChecksTitle}>
        {t('checks:image checks.form.select checks')}
      </div>
      <div className={st.ChecksContent}>
        <div className={st.ChecksItem}>
          <Checkbox
            {...register('deepfake')}
            id="deepfake"
            label={t('checks:estimations.deepfake.title') as unknown as string}
          />
        </div>
      </div>
    </div>
  );
}

export { ContentCheckForm };
